import React from 'react'
import 'src/pages/Form/Form.scss'
import Container from "src/components/Container/Container"
import { Form as FormikForm, Formik, FormikValues } from "formik"
import Heading from "src/components/Heading/Heading"
import Paragraph from "src/components/Paragraph/Paragraph"
import FormikField from "src/components/FormikField/FormikField"
import FormikCheckbox from "src/components/FormikCheckbox/FormikCheckbox"
import Button from "src/components/Button/Button"
import { useMutation } from "@tanstack/react-query"
import { apiProvider } from "src/api"
import ym from "react-yandex-metrika"
import { ButtonVariantsEnum } from "src/components/Button/types"
import { contactsValidation } from "src/validation"
import { useNavigate } from "react-router"
import Footer from "src/components/Footer/Footer"
import { runTypograph } from "src/helpers"

const Form = () => {

    const { mutate: sendContacts, isPending, isSuccess } = useMutation({
        mutationFn: async (variables: { values: FormikValues }) => {
            try {
                const response = await apiProvider.post(`${process.env.REACT_APP_SENDGRID_WEBHOOK}`, variables.values)
                ym('reachGoal', 'form-sent')
                localStorage.setItem("danetki-form-sent", "true")
                return response.data
            } catch (error) {
                console.error('error', error)
            }
        }
    })

    const navigate = useNavigate()

    return (
        <div className={"final__container"}>
            <Container
                containerOuterClassName={"final__outer-container"}
                containerInnerClassName={"final__inner-container"}
            >
                <div className={"final"}>
                    <div className={"final__image"}>
                        {isSuccess ?
                            <picture>
                                <source srcSet={"/form/form-second-desktop.png"} media="(min-width: 1280px)"/>
                                <img src="/form/form-second-mobile.png" alt=""/>
                            </picture>
                            :
                            <picture>
                                <source srcSet={"/form/form-first-desktop.png"} media="(min-width: 1280px)"/>
                                <img src="/form/form-first-mobile.png" alt=""/>
                            </picture>
                        }
                    </div>
                    <div className={"final__content-container"}>
                        {
                            isSuccess ?
                                <>
                                    <Heading
                                        className={"final__heading center"}
                                        size={2}
                                    >
                                        Осталось дождаться результатов
                                    </Heading>
                                    <Paragraph
                                        variant={1}
                                        className={"final__paragraph center"}
                                    >
                                        {runTypograph("Подведём итоги в новом году. А пока самое время загадать желание")}
                                    </Paragraph>
                                    <div className={"final__button-container"}></div>
                                    <Button
                                        onClick={() => navigate("/")}
                                        variant={ButtonVariantsEnum.TERTIARY}
                                    >
                                        Всё исполнится!
                                    </Button>
                                </>
                                :
                                <>
                                    <Heading size={2} className={"final__heading center"}>Твои контакты</Heading>
                                    <Paragraph variant={1} className={"final__paragraph center"}>
                                        {runTypograph(`Пришлём победителям письмо на почту или напишем в телеграм`)}
                                    </Paragraph>
                                    <Formik
                                        initialValues={{
                                            name: "",
                                            email: "",
                                            telegram: "",
                                            privacy_policy: false
                                        }}
                                        onSubmit={(values,) => {
                                            sendContacts({ values: values })
                                        }}
                                        validationSchema={contactsValidation}
                                        enableReinitialize={true}
                                    >
                                        {() => {
                                            return (
                                                <FormikForm
                                                    className={"final__fields"}
                                                >
                                                    <FormikField
                                                        name={"name"}
                                                        placeholder={"Имя и фамилия"}
                                                        readonly={isPending}
                                                        tabIndex={0}
                                                    />
                                                    <FormikField
                                                        name={"email"}
                                                        placeholder={"Электронная почта"}
                                                        readonly={isPending}
                                                        tabIndex={1}
                                                    />
                                                    <FormikField
                                                        name={"telegram"}
                                                        placeholder={"Телеграм"}
                                                        readonly={isPending}
                                                        tabIndex={2}
                                                    />
                                                    <FormikCheckbox
                                                        name={"privacy_policy"}
                                                        readonly={isPending}
                                                    />
                                                    <div className={"final__button-container"}>
                                                        <Button
                                                            type={"submit"}
                                                            variant={ButtonVariantsEnum.TERTIARY}
                                                            disabled={isPending}
                                                        >
                                                            Отправить
                                                        </Button>
                                                    </div>
                                                </FormikForm>
                                            )
                                        }}
                                    </Formik>
                                </>
                        }
                    </div>
                </div>
            </Container>
            <Footer className={"final__footer"}/>
        </div>
    )
}

export default Form